export default __webpack_public_path__ + "static/media/consorcioLogo.7f3dd403.svg";